export default __webpack_public_path__ + "static/media/2006-IMcover.3f99b9c3.jpg";